export const link = "https://api.xwolfstore.com/api/";
// export const link = "http://localhost:8060/api/";
export const REACT_APP_CHAT_ENDPOINT = "chat";
